/**
 * Single place for the API base URL. Trims whitespace and trailing slashes so
 * `${API_ENDPOINT}/api/...` always resolves correctly.
 */
function normalizeApiBase(url) {
  if (url == null || url === "") return "";
  return String(url).trim().replace(/\/+$/, "");
}

export const API_ENDPOINT = normalizeApiBase(process.env.REACT_APP_API_END_POINT);
